'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListIcon = function ListIcon(props) {
    return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '10', viewBox: '0 0 16 10' },
        _react2.default.createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd', transform: 'translate(-4 -7)' },
            _react2.default.createElement('rect', { width: '24', height: '24', fill: 'none' }),
            _react2.default.createElement('rect', { width: '12', height: '2', x: '8', y: '15', fill: props.color, rx: '1' }),
            _react2.default.createElement('rect', { width: '12', height: '2', x: '8', y: '11', fill: props.color, rx: '1' }),
            _react2.default.createElement('rect', { width: '12', height: '2', x: '8', y: '7', fill: props.color, rx: '1' }),
            _react2.default.createElement('circle', { cx: '5', cy: '8', r: '1', fill: props.color }),
            _react2.default.createElement('circle', { cx: '5', cy: '12', r: '1', fill: props.color }),
            _react2.default.createElement('circle', { cx: '5', cy: '16', r: '1', fill: props.color })
        )
    );
};

ListIcon.propTypes = {
    color: _propTypes2.default.string
};

ListIcon.defaultProps = {
    color: '#fff'
};

exports.default = ListIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/Icons/ListIcon/index.js
// module id = 802
// module chunks = 0